import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Theme
import { theme } from './theme';

// Components
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Layout from './components/Layout';
import Login from './pages/Login';
import DbProducts from './pages/DbProducts';
import FeedManager from './pages/FeedManager';
import WooSync from './pages/WooSync';
import Logs from './pages/Logs';
import AttributeValues from './pages/AttributeValues';
import SyncHealth from './pages/SyncHealth';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <CssBaseline />
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }
                >
                  <Route path="/db-products" element={<DbProducts />} />
                  <Route path="/feed-manager" element={<FeedManager />} />
                  <Route path="/woo-sync" element={<WooSync />} />
                  <Route path="/attribute-values" element={<AttributeValues />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/sync-health" element={<SyncHealth />} />
                  <Route path="/" element={<Navigate to="/db-products" replace />} />
                  <Route path="/settings" element={<Navigate to="/woo-sync" replace />} />
                  <Route path="*" element={<Navigate to="/db-products" replace />} />
                </Route>
              </Routes>
            </Router>
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
